import React, { useEffect } from "react";

import Filter from "./Section/Filter";
import { CodeManagementTable } from "./Section/code-management-table";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import { useSetState } from "../../../utils/hooks";
import Loading from "../../../components/ui/Loading/Loading";

function CodeManagementPage() {
  const [selectedFilter, setSelectedFilter] = React.useState({});
  const [submittedFilter, setSubmittedFilter] = React.useState({});
  const [searchBy, setSearchBy] = React.useState("name");
  const [searchByValue, setSearchByValue] = React.useState("");
  const [sortFilter, setSortFilter] = React.useState({});
  const [isResetted, setIsResetted] = React.useState(false);
  const [isResetting, setIsResetting] = React.useState(false);
  const [isResettedPage, setIsResettedPage] = React.useState(false);
  const filters = { ...submittedFilter, ...sortFilter };
  const resettedFilter = { ...sortFilter };
  const onChangeSearchBy = (id) => {
    setSearchBy(id);
  };

  const onSubmitFilter = () => {
    setIsResettedPage(true);
    setIsResetted(false);
    setSubmittedFilter({
      ...selectedFilter,
      [searchBy]: searchByValue,
    });
  };

  const onResetFilter = () => {
    setSelectedFilter({});
    setSubmittedFilter({});
    setSearchByValue("");
    setIsResetting(true);
    setIsResetted(true);
  };

  useEffect(() => {
    if (isResetting) {
      setTimeout(() => {
        setIsResetting(false);
      }, 500);
    }
  }, [isResetting]);

  const onChangeSearchByValue = (value) => {
    setSearchByValue(value);
  };

  useEffect(() => {
    if (isResettedPage) {
      setTimeout(() => {
        setIsResettedPage(false);
      }, 200);
    }
  }, [isResettedPage]);

  useEffect(() => {
    if (selectedFilter?.orderBy !== undefined) {
      setSortFilter({
        orderBy: selectedFilter["orderBy"],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter?.orderBy]);

  return (
    <>
      <div>
        <TitlePage title="코드관리" />
        {isResetting ? (
          <Loading />
        ) : (
          <>
            {isResetted ? (
              <Filter
                onSubmitFilter={onSubmitFilter}
                filter={selectedFilter}
                onFilter={setSelectedFilter}
                onResetFilter={onResetFilter}
                onChangeSearchBy={onChangeSearchBy}
                onChangeSearchByValue={onChangeSearchByValue}
              />
            ) : (
              <Filter
                onSubmitFilter={onSubmitFilter}
                filter={selectedFilter}
                onFilter={setSelectedFilter}
                onResetFilter={onResetFilter}
                onChangeSearchBy={onChangeSearchBy}
                onChangeSearchByValue={onChangeSearchByValue}
              />
            )}
          </>
        )}{" "}
        <div className="mt-4">
          <CodeManagementTable
            onSort={setSortFilter}
            isResettedPage={isResettedPage}
            filter={isResetted ? resettedFilter : filters}
          />
        </div>
      </div>
    </>
  );
}

export default CodeManagementPage;
